import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[tTemplate]' })
export class CxTableTemplate {
  @Input() type!: string;
  @Input('tTemplate') name!: string;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name;
  }
}
